module.exports = __webpack_public_path__ + "img/ih2.82ff02c9.png";